import { DatePicker, Form, Input, Select } from 'antd';
import { WrapperSelect } from 'common/components';
import { DOCUMENT_CERTIFICATE_LIMIT_CHARACTER } from 'pages/qa-spec/constant';
import { DATE_FORMAT, DOCUMENT_CERTIFICATE_FIELD } from 'static/Constants';
import { DEFAULT_CERTIFICATE_FORM } from './constants';
import { TOOlTIP_FIELDS } from 'static/tooltipFields';
import { QaSpecHelpContentLabel } from 'pages/qa-spec/components/shared/QaSpecHelpContent';
import TraceableCommentContainer from 'pages/traceable-comment/TraceableCommentContainer';
import { COMMENT_FIELDS } from 'static/QaSpecFields';

const layoutCol = {
  labelCol: {
    xxl: { span: 10 },
    xl: { span: 10 },
  },
  wrapperCol: {
    xxl: { span: 14 },
    xl: { span: 14 },
  },
};

const CertificateForm = ({ form, ...restProps }) => {
  return (
    <Form
      form={form}
      {...layoutCol}
      initialValues={DEFAULT_CERTIFICATE_FORM}
      {...restProps}
    >
      <Form.Item
        name='type'
        label={
          <TraceableCommentContainer
            qaSpecName={COMMENT_FIELDS.documentAndCertificate.qaSpecName}
            qaSpecFieldName='Type'
          >
            <QaSpecHelpContentLabel
              fieldPath={TOOlTIP_FIELDS.type.fieldPath}
            >
              Type
            </QaSpecHelpContentLabel>
          </TraceableCommentContainer>
        }
        required
      >
        <WrapperSelect disabled>
          <Select.Option value='Document'>Document</Select.Option>
        </WrapperSelect>
      </Form.Item>

      <Form.Item
        name='subtype'
        label={
          <TraceableCommentContainer
            qaSpecName={COMMENT_FIELDS.documentAndCertificate.qaSpecName}
            qaSpecFieldName='Sub Type'
          >
            <QaSpecHelpContentLabel
              fieldPath={TOOlTIP_FIELDS.certificateSubType.fieldPath}
            >
              Sub Type
            </QaSpecHelpContentLabel>
          </TraceableCommentContainer>
        }
        required
      >
        <WrapperSelect disabled>
          <Select.Option value='Certificate'>Certificate</Select.Option>
        </WrapperSelect>
      </Form.Item>
      <Form.Item
        label={
          <TraceableCommentContainer
            qaSpecName={COMMENT_FIELDS.documentAndCertificate.qaSpecName}
            qaSpecFieldName='Certificate Type'
          >
            <QaSpecHelpContentLabel
              fieldPath={TOOlTIP_FIELDS.certificateType.fieldPath}
            >
              Certificate Type
            </QaSpecHelpContentLabel>
          </TraceableCommentContainer>
        }
        name='certificateType'
      >
        <WrapperSelect>
          {DOCUMENT_CERTIFICATE_FIELD?.slice()
            .sort()
            .map((item, index) => {
              return (
                <Select.Option key={index} value={item}>
                  {item}
                </Select.Option>
              );
            })}
        </WrapperSelect>
      </Form.Item>
      <Form.Item
        label={
          <TraceableCommentContainer
            qaSpecName={COMMENT_FIELDS.documentAndCertificate.qaSpecName}
            qaSpecFieldName='Certificate'
          >
            <QaSpecHelpContentLabel
              fieldPath={TOOlTIP_FIELDS.certificateName.fieldPath}
            >
              Certificate
            </QaSpecHelpContentLabel>
          </TraceableCommentContainer>
        }
        name='certificate'
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={
          <TraceableCommentContainer
            qaSpecName={COMMENT_FIELDS.documentAndCertificate.qaSpecName}
            qaSpecFieldName='Certificate Body'
          >
            <QaSpecHelpContentLabel
              fieldPath={TOOlTIP_FIELDS.certificateBody.fieldPath}
            >
              Certificate Body
            </QaSpecHelpContentLabel>
          </TraceableCommentContainer>
        }
        name='certificateBody'
      >
        <Input
          showCount
          maxLength={DOCUMENT_CERTIFICATE_LIMIT_CHARACTER.certificateBody}
        />
      </Form.Item>
      <Form.Item
        label={
          <TraceableCommentContainer
            qaSpecName={COMMENT_FIELDS.documentAndCertificate.qaSpecName}
            qaSpecFieldName='Certificate Expiry Date'
          >
            <QaSpecHelpContentLabel
              fieldPath={TOOlTIP_FIELDS.certificateExpiryDate.fieldPath}
            >
              Certificate Expiry Date
            </QaSpecHelpContentLabel>
          </TraceableCommentContainer>
        }
        name='certificateExpiryDate'
        rules={[
          { required: true, message: 'Please select certificate expiry date!' },
        ]}
      >
        <DatePicker
          style={{ width: '90%' }}
          placeholder='Select date'
          format={DATE_FORMAT.SYSTEM_FORMAT}
        />
      </Form.Item>
    </Form>
  );
};

export default CertificateForm;
